import React, { useMemo } from 'react';
import MapStyle from '../../MapStyle';
import { GoogleMap } from '@react-google-maps/api';
import {
  Skeleton
} from '@mui/material';

const google = window.google;

const DEFAULT_CENTER = { lat: 37.09024, lng: -95.712891 };

const safeLat = (lat?: string | number) => {
  const numericLat = typeof lat === 'string' ? parseFloat(lat) : lat;
  return Number.isFinite(numericLat) ? (numericLat as number) : DEFAULT_CENTER.lat;
};
const safeLng = (lng?: string | number) => {
  const numericLng = typeof lng === 'string' ? parseFloat(lng) : lng;
  return Number.isFinite(numericLng) ? (numericLng as number) : DEFAULT_CENTER.lng;
};

interface LocationProfileMapPreviewProps {
  lat?: string | number;
  lng?: string | number;
  loading?: boolean;
}

const LocationProfileMapPreview = (props: LocationProfileMapPreviewProps) => {
  const { lat, lng, loading } = props;
  const coordinates = useMemo(() => new google.maps.LatLng(safeLat(lat), safeLng(lng)), [lat, lng]);

  return loading ? <Skeleton variant="rectangular" width={"100%"} height={359} /> : <GoogleMap center={coordinates}
    zoom={12}
    mapContainerClassName='ss-location-profile-map-preview-container'
    options={{
      styles: MapStyle,
      mapTypeControl: false,
      disableDefaultUI: true,
      draggable: false,
      disableDoubleClickZoom: false,
      zoomControl: false,
    }}
  />
}

export default LocationProfileMapPreview;
